/**
 * @generated SignedSource<<9c9dc48fcece250828cf7cd3ab60bba1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type StatusValue = "ERROR" | "PARTIAL_SUCCESS" | "SKIPPED" | "SUCCESS" | "UNAVAILABLE" | "%future added value";
export type UpsertAWSAccountDiscoveryInput = {
  custodianRole?: string | null | undefined;
  description?: string | null | undefined;
  externalID?: string | null | undefined;
  memberRole?: string | null | undefined;
  name?: string | null | undefined;
  orgReadRole: string;
};
export type UpsertAWSAccountDiscoveryMutation$variables = {
  input: UpsertAWSAccountDiscoveryInput;
};
export type UpsertAWSAccountDiscoveryMutation$data = {
  readonly upsertAWSAccountDiscovery: {
    readonly accountDiscovery: {
      readonly config: {
        readonly custodianRole?: string;
        readonly externalID?: string | null | undefined;
        readonly memberRole?: string;
        readonly orgID?: string;
        readonly orgRole?: string;
      };
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly provider: CloudProvider;
      readonly schedule: {
        readonly suspended: boolean;
      };
      readonly statusInfo: {
        readonly details: ReadonlyArray<{
          readonly at: string | null | undefined;
          readonly component: string;
          readonly message: string | null | undefined;
          readonly status: StatusValue;
        }>;
      };
    };
  } | null | undefined;
};
export type UpsertAWSAccountDiscoveryMutation = {
  response: UpsertAWSAccountDiscoveryMutation$data;
  variables: UpsertAWSAccountDiscoveryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "custodianRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgRole",
      "storageKey": null
    }
  ],
  "type": "AWSAccountDiscoveryConfig",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountDiscoverySchedule",
  "kind": "LinkedField",
  "name": "schedule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "suspended",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusInfo",
  "kind": "LinkedField",
  "name": "statusInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusDetail",
      "kind": "LinkedField",
      "name": "details",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "component",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertAWSAccountDiscoveryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpsertAccountDiscoveryPayload",
        "kind": "LinkedField",
        "name": "upsertAWSAccountDiscovery",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDiscovery",
            "kind": "LinkedField",
            "name": "accountDiscovery",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpsertAWSAccountDiscoveryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpsertAccountDiscoveryPayload",
        "kind": "LinkedField",
        "name": "upsertAWSAccountDiscovery",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDiscovery",
            "kind": "LinkedField",
            "name": "accountDiscovery",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6be0dee1f407a1c3ba6ee2d634f984f0",
    "id": null,
    "metadata": {},
    "name": "UpsertAWSAccountDiscoveryMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertAWSAccountDiscoveryMutation(\n  $input: UpsertAWSAccountDiscoveryInput!\n) {\n  upsertAWSAccountDiscovery(input: $input) {\n    accountDiscovery {\n      config {\n        __typename\n        ... on AWSAccountDiscoveryConfig {\n          custodianRole\n          externalID\n          memberRole\n          orgID\n          orgRole\n        }\n      }\n      description\n      id\n      name\n      provider\n      schedule {\n        suspended\n      }\n      statusInfo {\n        details {\n          at\n          component\n          message\n          status\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e05cbb3c0cad4ebd1ee7ef3f94772ded";

export default node;
